import React from 'react';
import Input from 'components/Input';
import { withTranslation } from 'react-i18next';
import { FormProvider, useForm } from 'react-hook-form'
import { Button } from '@mui/material';

const AddSettlement = ({ t }) => {
  const method = useForm({
    mode: 'all'
  })
  const { watch, register } = method

  const fields = [
    {
      name: 'payment_option',
      placeholder: 'Secel payment method',
      label: 'Payment Method',
      options: [
        {
          label: t('settings.bank_settlement.transfer'),
          value: 'Bank transfer'
        },
        {
          label: t('settings.bank_settlement.momo'),
          value: 'Mobile money transfer'
        }
      ]
    },
    // [
    //   {
    //     name: 'bank_name',
    //     label: t('settings.bank_settlement.name'),
    //     placeholder: 'Eg. Ecobank Nigeria'
    //   },
    //   {
    //     name: 'bank_branch',
    //     label: t('settings.bank_settlement.name'),
    //     placeholder: 'Eg. Ikeja branch'
    //   },
    // ],

    {
      name: 'bank_name',
      label: t('settings.bank_settlement.name'),
      placeholder: 'Eg. Ecobank Nigeria'
    },
    {
      name: 'account_name',
      label: t('settings.bank_settlement.acc.label'),
      placeholder: t('settings.bank_settlement.acc.value')
    },
    {
      name: 'account_no',
      label: t('settings.bank_settlement.num'),
      placeholder: 'Eg. 7239492874'
    },
  ];
  return (
    <FormProvider {...method}>
      {
        fields.map(({ name, placeholder, label, options }, index) => {
          return (
            <div className="w-full mb-3 px-[20px]" key={index.toString()} style={{ display: name === 'bank_name' && watch('payment_option') === 'Mobile money transfer' ? 'none' : 'block' }}>
              <Input
                classList="w-full rounded-md p-2"
                label={label}
                name={name}
                placeholder={placeholder}
                options={options}
                {...register(name)}
              />
            </div>
          )
        })
      }
      <div className='flex w-full justify-evenly'>
        <Button variant='outlined' color='primary' className='px-8 rounded-[16px] py-3 w-[40%] my-3'>
          Cancel
        </Button>
        <Button variant='contained' color='primary' className='px-8 rounded-[16px] py-3 w-[40%] my-3 bg-primary'>
          Save
        </Button>
      </div>
    </FormProvider>
  )
}
export default withTranslation()(AddSettlement);